import { saveAs } from 'file-saver';
import PropTypes from 'prop-types';
import React from 'react';

import { showToast } from '~/components/Shared/EcToast/showToast';
import { useFormatDate } from '~/i18n/hooks/useFormatDate/useFormatDate';
import { ERROR, SUCCESS } from '~/types/toast.types';
import Link from '~/ui/components/Link/Link';
import { parseApiError } from '~/utils/parseApiError';

import { downloadImportResultsExcelFile } from '../UsersPage.data';

const DownloadImportResultsFileLink = ({
  text,
  importId,
  clientId,
  resultType,
}) => {
  const formatDate = useFormatDate();
  const handleImportErrorsFileDownloadClick = async () => {
    try {
      const result = await downloadImportResultsExcelFile({
        clientId,
        importId,
        resultType,
      });

      showToast(SUCCESS, `${resultType} file downloaded successfully.`);
      const timestamp = formatDate(new Date(), 'utc');
      const filename = `evisort-users-${resultType}-${timestamp}.xlsx`;
      saveAs(result, filename);
    } catch (errorResponse) {
      handleApiError(errorResponse);
    }
  };

  const handleApiError = (errorResponse) => {
    const error = parseApiError(errorResponse);
    showToast(ERROR, error.message);
  };

  return (
    <Link variant="body2" onClick={handleImportErrorsFileDownloadClick}>
      {text}
    </Link>
  );
};

DownloadImportResultsFileLink.propTypes = {
  text: PropTypes.string.isRequired,
  importId: PropTypes.number.isRequired,
  clientId: PropTypes.number.isRequired,
  resultType: PropTypes.any.isRequired, // @TODO check for value in BulkImportUserResultType
};

export default DownloadImportResultsFileLink;
